// Team picker blocks for Workspace › Tasks — bold coloured tiles with open + people counts.
import { Lock, Users, Layers, User } from "lucide-react";
import { teamColor, inkHex } from "../_shared";

function Block({ on, color, onClick, testid, title, children }) {
  return (
    <button onClick={onClick} title={title} data-testid={testid}
      className="group relative text-left rounded-xl border px-3 py-2.5 overflow-hidden transition-[transform,background-color,border-color] duration-150 hover:-translate-y-0.5"
      style={{ borderColor: on ? color : "rgba(255,255,255,.08)", background: on ? `${color}26` : `linear-gradient(135deg, ${color}14, rgba(255,255,255,.015) 60%)` }}>
      <span className="absolute inset-y-0 left-0 w-1" style={{ background: color }} />
      {children}
    </button>
  );
}

export default function TeamBlocks({ teams, value, onChange, totalOpen }) {
  const personalCol = inkHex("#94a3b8");
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6 gap-2" data-testid="task-team-chips">
      <Block on={!value} color={inkHex("#fbbf24")} onClick={() => onChange("")} testid="task-team-all" title="Every team and personal task">
        <div className="flex items-center gap-1.5 text-[13.5px] font-semibold text-white"><Layers className="w-3.5 h-3.5 text-amber-300" />Everyone</div>
        <div className="text-[10.5px] font-mono text-slate-400 mt-0.5">All teams · {totalOpen} open in teams</div>
      </Block>
      <Block on={value === "_none"} color={personalCol} onClick={() => onChange(value === "_none" ? "" : "_none")} testid="task-team-none" title="Personal tasks with no team">
        <div className="flex items-center gap-1.5 text-[13.5px] font-semibold text-white"><User className="w-3.5 h-3.5 text-slate-300" />Personal</div>
        <div className="text-[10.5px] font-mono text-slate-400 mt-0.5">No team</div>
      </Block>
      {teams.map((t) => { const c = teamColor(t); return (
        <Block key={t.id} on={value === t.id} color={c} onClick={() => onChange(value === t.id ? "" : t.id)} testid={`task-team-${t.id}`} title={t.description || t.name}>
          <div className="flex items-center gap-1.5 text-[13.5px] font-semibold text-white truncate">
            <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ background: c }} /><span className="truncate">{t.name}</span>
            {t.visibility === "private" && <Lock className="w-3 h-3 text-amber-300 shrink-0" />}
          </div>
          <div className="text-[10.5px] font-mono text-slate-400 mt-0.5 flex items-center gap-2">
            <span style={{ color: (t.open_count || 0) ? c : undefined }}>{t.open_count ?? 0} open</span>
            <span className="inline-flex items-center gap-0.5"><Users className="w-3 h-3" />{t.people_count ?? (t.member_ids || []).length}</span>
          </div>
        </Block>); })}
    </div>
  );
}
